(function () {
  if (window.__raAboutInit) return;
  window.__raAboutInit = true;
  document.documentElement.classList.add('ra-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    if (el.dataset.raDone) return;
    el.dataset.raDone = '1';
    var raw = el.getAttribute('data-count') || el.textContent;
    var match = raw.match(/[\d,.]+/);
    if (!match || reduce) return;
    var target = parseFloat(match[0].replace(/,/g, ''));
    var prefix = raw.slice(0, match.index);
    var suffix = raw.slice(match.index + match[0].length);
    var useComma = match[0].indexOf(',') > -1;
    var start = null, dur = 1600;
    function fmt(n) {
      n = Math.round(n);
      return useComma ? n.toLocaleString('en-US') : String(n);
    }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }
    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(step);
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.hasAttribute('data-count')) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function init(root) {
    var els = (root || document).querySelectorAll('.ra-reveal, [data-count]');
    els.forEach(function (el) {
      if (io && !reduce) io.observe(el);
      else el.classList.add('is-in');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
